"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableCheckActionIconSelect = /** @class */ (function (_super) {
    __extends(TableCheckActionIconSelect, _super);
    function TableCheckActionIconSelect(props) {
        return _super.call(this, props) || this;
    }
    TableCheckActionIconSelect.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick(this.props.selected);
        }
    };
    TableCheckActionIconSelect.prototype.getOIcon = function () {
        return this.props.icon + "-o";
    };
    TableCheckActionIconSelect.prototype.getRenderObject = function () {
        if (this.props.selected) {
            return (React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: this.props.icon, 
                //theme={"filled"}
                type: "danger", style: { marginLeft: "1px", marginRight: "1px" }, onClick: this.buttonClick.bind(this) }));
        }
        else {
            return (React.createElement(antd_1.Button, { shape: "circle", size: "small", icon: this.props.icon, ghost: true, type: "primary", style: { marginLeft: "1px", marginRight: "1px" }, onClick: this.buttonClick.bind(this) }));
        }
    };
    TableCheckActionIconSelect.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" }, this.getRenderObject()));
    };
    return TableCheckActionIconSelect;
}(React.Component));
exports.default = TableCheckActionIconSelect;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/TableCheckActionIconSelect.tsx
// module id = 785
// module chunks = 0